import React, { useEffect, useState } from 'react';
import styles from './timeline.module.css';
import truckIcon from "../../Assests/Images/truckicon.svg";
import badgeIcon from "../../Assests/Images/badgeicon.svg";
import userIcon from "../../Assests/Images/usericon.svg";

const Timeline = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          setActiveStep(prevStep => {
            if (prevStep >= 5) return 0;
            return prevStep + 1;
          });
          return 0;
        }
        return prev + 5;
      });
    }, 160);

    return () => clearInterval(interval);
  }, []);

  const getCircleProgress = (circleIndex) => {
    if (circleIndex === 0 && activeStep === 0) return progress;
    if (circleIndex === 1 && activeStep === 2) return progress;
    if (circleIndex === 2 && activeStep === 4) return progress;
    if (circleIndex === 0 && activeStep > 0) return 100;
    if (circleIndex === 1 && activeStep > 2) return 100;
    if (circleIndex === 2 && activeStep > 4) return 100;
    return 0;
  };

  const getLineProgress = (lineIndex) => {
    if (lineIndex === 0 && activeStep === 1) return progress;
    if (lineIndex === 1 && activeStep === 3) return progress;
    if (lineIndex === 0 && activeStep > 1) return 100;
    if (lineIndex === 1 && activeStep > 3) return 100;
    return 0;
  };

  const isCircleActive = (circleIndex) => {
    return (
      (circleIndex === 0 && activeStep >= 0) ||
      (circleIndex === 1 && activeStep >= 2) ||
      (circleIndex === 2 && activeStep >= 4)
    );
  };

  const isLineActive = (lineIndex) => {
    return (
      (lineIndex === 0 && activeStep >= 1) ||
      (lineIndex === 1 && activeStep >= 3)
    );
  };

  // Only show shadow when the circle is actively filling (progress > 0 and < 100)
  const isCircleFilling = (circleIndex: number) => {
    if (circleIndex === 0 && activeStep === 0 && progress > 0 && progress < 100) return true;
    if (circleIndex === 1 && activeStep === 2 && progress > 0 && progress < 100) return true;
    if (circleIndex === 2 && activeStep === 4 && progress > 0 && progress < 100) return true;
    return false;
  };

  return (
    <div style={{ background: "#fff", padding: 0 }}>
      <h1 className={styles.heading2} style={{  marginBottom: 10, marginTop: 40 }}>
        Why Partner with Hyproc International?
      </h1>
      <div className={styles.timelineContainer}>
        {/* Step 1 */}
        <div className={styles.step}>
          <div
            className={`${styles.circleWrapper} ${isCircleFilling(0) ? styles.activeShadow : ""}`}
          >
            <svg className={styles.progressSvg}>
              <circle className={styles.bgCircle} cx="70" cy="70" r="63" />
              <circle
                className={styles.fgCircle}
                cx="70"
                cy="70"
                r="63"
                style={{ strokeDashoffset: 439.6 - (439.6 * getCircleProgress(0)) / 100 }}
              />
              <foreignObject x="35" y="35" width="70" height="70">
                <img
                  src={truckIcon}
                  alt="Truck"
                  width="70"
                  height="70"
                  style={{ opacity: isCircleActive(0) ? 1 : 0.5 }}
                />
              </foreignObject>
            </svg>
          </div>
          <div className={styles.stepText}>
            <h3>End-to-End Supply Chain Expertise</h3>
            <p>Procurement, logistics, and compliance all in one place.</p>
          </div>
        </div>

        {/* Line 1 */}
        <div className={styles.lineContainer}>
          <div
            className={`${styles.lineFiller} ${isLineActive(0) ? styles.activeLine : ''}`}
            style={{ width: `${getLineProgress(0)}%` }}
          ></div>
        </div>

        {/* Step 2 */}
        <div className={styles.step}>
          <div
            className={`${styles.circleWrapper} ${isCircleFilling(1) ? styles.activeShadow : ""}`}
          >
            <svg className={styles.progressSvg}>
              <circle className={styles.bgCircle} cx="70" cy="70" r="63" />
              <circle
                className={styles.fgCircle}
                cx="70"
                cy="70"
                r="63"
                style={{
                  strokeDashoffset: 439.6 - (439.6 * getCircleProgress(1)) / 100
                }}
              />
              <foreignObject x="35" y="35" width="70" height="70">
                <img
                  src={badgeIcon}
                  alt="Badge"
                  width="70"
                  height="70"
                  style={{ opacity: isCircleActive(1) ? 1 : 0.5 }}
                />
              </foreignObject>
            </svg>
          </div>
          <div className={styles.stepText}>
            <h3>Proven Reliability</h3>
            <p>Decades of experience delivering results across industries.</p>
          </div>
        </div>

        {/* Line 2 */}
        <div className={styles.lineContainer}>
          <div
            className={`${styles.lineFiller} ${isLineActive(1) ? styles.activeLine : ''}`}
            style={{ width: `${getLineProgress(1)}%` }}
          ></div>
        </div>

        {/* Step 3 */}
        <div className={styles.step}>
          <div
            className={`${styles.circleWrapper} ${isCircleFilling(2) ? styles.activeShadow : ""}`}
          >
            <svg className={styles.progressSvg}>
              <circle className={styles.bgCircle} cx="70" cy="70" r="63" />
              <circle
                className={styles.fgCircle}
                cx="70"
                cy="70"
                r="63"
                style={{
                  strokeDashoffset: 439.6 - (439.6 * getCircleProgress(2)) / 100
                }}
              />
              <foreignObject x="35" y="35" width="70" height="70">
                <img
                  src={userIcon}
                  alt="User"
                  width="70"
                  height="70"
                  style={{ opacity: isCircleActive(2) ? 1 : 0.5 }}
                />
              </foreignObject>
            </svg>
          </div>
          <div className={styles.stepText}>
            <h3>Client-First Approach</h3>
            <p>Personalized service with a dedicated account manager.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Timeline;